module.exports = __webpack_public_path__ + "img/SLN_thumb_320_2123.498460e7.jpg";